import Vue from 'vue'
import VueRouter from 'vue-router'
import routes, { ORDER_ROLES, CMS_ROLES } from './routes'
import jwtService from './mixins/JwtStorageService'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// Domyślna trasa po zalogowaniu / po odmowie dostępu, zależnie od ról.
// '/images' jest dostępne dla każdego zalogowanego, więc nie ma ryzyka pętli
// przekierowań nawet dla konta bez rozpoznanej roli.
function defaultPath(roles) {
    if (ORDER_ROLES.some(role => roles.includes(role))) {
        return '/'
    }
    if (CMS_ROLES.some(role => roles.includes(role))) {
        return '/infos'
    }
    return '/images'
}

router.beforeEach((to, from, next) => {
    // Wygasłe tokeny nie dają dostępu — patrz hasRestorableSession()
    const logged = jwtService.hasRestorableSession()

    if (to.meta && to.meta.public) {
        if (logged) {
            return next(defaultPath(jwtService.getRoles() || []))
        }
        return next()
    }

    if (!logged) {
        return next('/login')
    }

    const allowed = to.meta && to.meta.roles
    if (allowed) {
        const roles = jwtService.getRoles() || []
        if (!allowed.some(role => roles.includes(role))) {
            return next(defaultPath(roles))
        }
    }

    next()
})

export default router
